
import Vue from "vue";
import AppProjectSelectContact from "./ProjectSelectContact.vue";
import AppProjectEditProperties from "./ProjectEditProperties.vue";
import {Contact, Project} from "@/models/base";

export default Vue.extend({

	props: {
		project: {
			type: Object as ()=>Project,
			required: true
		},
		lg: {
			type: [Number, String]
		},
		md: {
			type: [Number, String]
		}
	},
	methods: {
		clearContact() {
			this.project.Contact = new Contact();
			this.project.ContactID = 0;
		},
		save(){
			this.$emit("save");
		},
		triggerPhone(value:string){
			this.$emit("trigger-phone", value);
		}
	},
	components: {
		AppProjectSelectContact,
		AppProjectEditProperties,
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});

